/**
 * 統計データ記録
 *
 * ゲーム終了時に呼び出され、localStorage に統計を保存する。
 */
import { loadStatistics, saveStatistics, type MapStatistics } from './storage';
import type { ScoreMetadata } from '../config/achievements';

// 1ゲームにつき1回だけ記録するためのガード
// 新ゲーム開始時にページリロードされるのでリセットされる
let recorded = false;

function emptyStats(): MapStatistics {
  return {
    playCount: 0,
    clearCount: 0,
    noUndoClearCount: 0,
    bestScore: -Infinity,
    sumCash: 0,
    sumShares: 0,
    sumLoco: 0,
    sumLinks: 0,
  };
}

/**
 * ゲーム結果を統計に記録
 */
export function recordGameResult(
  apiMapType: string,
  isVictorious: boolean,
  metadata: ScoreMetadata,
  unifiedFinalScore: number,
): void {
  if (recorded) return;
  recorded = true;

  const allStats = loadStatistics();
  const stats = allStats[apiMapType] || emptyStats();

  // プレイ回数は常に +1
  stats.playCount += 1;

  if (isVictorious) {
    stats.clearCount += 1;

    // やり直しなしクリア
    if ((metadata.undoCount as number) === 0) {
      stats.noUndoClearCount += 1;
    }

    // 最高スコア更新
    if (unifiedFinalScore > stats.bestScore) {
      stats.bestScore = unifiedFinalScore;
    }

    // 累計値（平均算出用）
    stats.sumCash += (metadata.cash as number) || 0;
    stats.sumShares += metadata.sharesIssued;
    stats.sumLoco += (metadata.locomotiveLevel as number) || 0;
    stats.sumLinks += (metadata.completedLinks as number) || 0;

    // Seattle 追加項目
    if (metadata.cargoTransportLevel !== undefined) {
      stats.sumCargoLv = (stats.sumCargoLv || 0) + (metadata.cargoTransportLevel as number);
      stats.sumDelivered = (stats.sumDelivered || 0) + (metadata.deliveredCubes as number);
      stats.sumRemaining = (stats.sumRemaining || 0) + (metadata.remainingGoods as number);
      stats.sumUnconnected = (stats.sumUnconnected || 0) + (metadata.unconnectedStations as number);
    }
  }

  allStats[apiMapType] = stats;
  saveStatistics(allStats);
}
